<template>
    <div>
        <v-layout row wrap>
            <v-flex xs12 sm6 md4 pa-1 v-for="territory in territories" :key="territory.id">
                <ctlTerritoryCard
                    :territory="territory"
                    @onEditTerritory="onEditTerritory"
                    @onTerritorySaved="onTerritorySaved"
                ></ctlTerritoryCard>

            </v-flex>
        </v-layout>
    </div>
</template>
<script>
import ctlTerritoryCard from './ctlTerritoryCard';
export default {
    props: ['territories'],
    components: {
        'ctlTerritoryCard':ctlTerritoryCard
    },
    data() {
        return {}
    },
    computed: {
        // showTerritoryPopup () {
        //     return !!this.territoryToShow
        // },
        // showTerritoryEditPopup () {
        //     return !!this.territoryIdToEdit
        // },
    },
    methods: {
        // onCloseRegionEdit() {
        //     this.$emit('onTerritorySaved')
        // },
        onEditTerritory(id) {
            // console.log('id:' + id)
            this.$emit('onEditTerritory', id)
        },
        onShowTerritoryCard(territory) {
            this.$emit('onShowTerritoryCard', territory)
        },
        onTerritorySaved() {
            this.$emit('onTerritorySaved')
        },
        // onCloseTerritory() {
        //     this.territoryToShow = null
        // },
    },
}
</script>
